import React from 'react';
import HeadingComponent from './headingComponent/HeadingComponent';
import { Link } from 'react-router-dom';

import img1 from '../assets/solarrooftopsolutions/1.png';
import img2 from '../assets/solarrooftopsolutions/2.png';
import img3 from '../assets/solarrooftopsolutions/3.png';
import img4 from '../assets/solarrooftopsolutions/4.png';
import img5 from '../assets/solarrooftopsolutions/5.png';
import img6 from '../assets/solarrooftopsolutions/6.png';
import img7 from '../assets/solarrooftopsolutions/7.png';
import img8 from '../assets/solarrooftopsolutions/8.png';

const goToTopBtn = () => {
	window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
};

const RoofTopItem = ({ to, imgSrc, alt, title }) => (
	<div className='RWrapper'>
		<Link to={to} onClick={goToTopBtn}>
			<img src={imgSrc} alt={alt} height='100px' style={{ margin: '0 auto' }} />
			<h6 className='text-center my-2 roof-top-title'>{title}</h6>
		</Link>
	</div>
);

const RoofTopSolorSolutions = () => {
	return (
		<div className='container-fluid mb-4'>
			<HeadingComponent headerName={'Rooftop Solar Solution'} />
			<div className='searchByMenu'>
				<RoofTopItem
					to='/solarExpert'
					imgSrc={img1}
					alt='1'
					title='SOLAR CONSULTANCY'
				/>
				<RoofTopItem
					to='/survey'
					imgSrc={img2}
					alt=''
					title='Book Free Solar Site Survey'
				/>
				<RoofTopItem
					to='/solarExpert'
					imgSrc={img3}
					alt=''
					title='SOLAR INSURANCE'
				/>
				<RoofTopItem
					to='/solarExpert'
					imgSrc={img4}
					alt=''
					title='SOLAR FINANCING'
				/>
				<RoofTopItem
					to='/solarExpert'
					imgSrc={img5}
					alt=''
					title='SOLAR INSTALLATION & COMMISSIONING'
				/>
				<RoofTopItem
					to='/solarExpert'
					imgSrc={img6}
					alt=''
					title='SOLAR ENGINEERING & DESIGNING'
				/>
				<RoofTopItem
					to='/solarExpert'
					imgSrc={img7}
					alt=''
					title='SOLAR PANEL CLENAING & SERVICE'
				/>
				<RoofTopItem to='/solarExpert' imgSrc={img8} alt='' title='SOLAR AMC' />
			</div>
		</div>
	);
};

export default RoofTopSolorSolutions;
